import React, {Component} from 'react';
import {Nav,NavItem,NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import '../AdminPage/admin.css';

class Admin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            usersid: '234',
            usersname: 'test',
            usersemail: 'test@test.com',
            userspurchases: [{id: 3450930894, product: 'state table lamp', price: '$20'}],
            blocked: false
            
        }
    }

    render() {
        return(
            <div>
                <div className="App-header">
                </div>

                <Nav>
                    <NavItem>
                      <NavLink href="/admin"><Link to="/admin">Admin Home</Link></NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/adminblog"><Link to="/adminblog">Admin Blog</Link></NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/adminstore"><Link to="/adminstore">Admin store</Link></NavLink>
                    </NavItem>
                </Nav> 
                Users
                <div>
                    Usersname: {this.state.usersname}, Usersemail: {this.state.usersemail}
                    purchases: 
                    {
                        this.state.userspurchases.map((purchase) => {
                            return( <div> ID: {purchase.id} Product: {purchase.product} Price: {purchase.price} </div>)
                        }) 
                    }
                </div>
            </div>
                
        )
    }
    }


export default Admin